/* eslint-disable no-useless-escape */
export function validateEmail(value: string) {
  const indexDog = value.indexOf('@');
  const indexDot = value.lastIndexOf('.');
  // eslint-disable-next-line
  const afterDog = indexDog > 0 ? value.substring(indexDog + 1, indexDot).replace(/[0-9`~!#$@.%^&*()_|+\-=?;:'",<>\{\}\[\]\\\/]/g, '') : '';
  // eslint-disable-next-line
  const strEnd = indexDot > 0 ? value.substring(indexDot + 1).replace(/[0-9`~!#$@.%^&*()_|+\-=?;:'",<>\{\}\[\]\\\/]/g, '') : '';
  const tab = value.includes('\t');
  if (
    !tab &&
    indexDot > 0 &&
    indexDog > 0 &&
    indexDog < indexDot &&
    afterDog.length > 0 &&
    strEnd.length >= 2 &&
    !value.includes(' ') &&
    // eslint-disable-next-line
    !RegExp(/[`~!#$@.%^&*()_|+\-=?;:'",<>\{\}\[\]\\\/]/).test(value[0]) &&
    // eslint-disable-next-line
    !RegExp(/[`~!#$%^&*()|+=?;:'",<>\{\}\[\]\\\/]/).test(value)
  ) {
    return true;
  }
  return false;
}
export function validatePhone(value: string) {
  const str = value.replace(/[^0-9.]/g, '');
  if (str.length === 10) {
    return true;
  }
  return false;
}

export function delay(ms: number) {
  return new Promise(function (resolve) {
    setTimeout(resolve, ms);
  });
}

export function getCutText(text: string, size: number): string {
  if (!text || typeof text !== 'string') {
    return '';
  }
  if (text.length < size) {
    return text;
  }

  return text.slice(0, size) + '...';
}
